var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomePhoneAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.729,
    height: 40.729,
    viewBox: "0 0 40.729 40.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M39.567,28.781l-8.909-3.818a1.909,1.909,0,0,0-2.227.549l-3.946,4.821a29.486,29.486,0,0,1-14.1-14.1l4.821-3.946a1.9,1.9,0,0,0,.549-2.227L11.94,1.154A1.922,1.922,0,0,0,9.753.048L1.48,1.958A1.909,1.909,0,0,0,0,3.818,36.907,36.907,0,0,0,36.911,40.729a1.909,1.909,0,0,0,1.861-1.48l1.909-8.273a1.932,1.932,0,0,0-1.114-2.2Z",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomePhoneAlt);
export default __webpack_public_path__ + "static/media/Iconawesome-phone-alt.e65a273df8016536c7c827185392d6fa.svg";
export { ForwardRef as ReactComponent };